import { getGameSchema, getItemListSchema, getQuizSchema } from '@/constants/pageMetadata';
import { getFullUrl } from '@/lib/utils/url';
import type { QuizQuestion } from '@/lib/services/questions';
import type { Tag } from '@/lib/services/tags';
import { routes } from '@/routes';

export function getDailyChallengeSchemas(description: string): object[] {
  return getGameSchemas('Daily Challenge', routes.dailyChallenge, description);
}

export function getEndlessTriviaSchemas(description: string): object[] {
  return getGameSchemas('Endless Trivia', routes.endlessTrivia, description);
}

interface GetTagSchemasOptions {
  name: string;
  categoryName: string;
  description: string;
  childTags: Tag[];
  miniQuizQuestions?: QuizQuestion[];
}

export function getTagSchemas({
  name,
  categoryName,
  description,
  childTags,
  miniQuizQuestions,
}: GetTagSchemasOptions): object[] {
  const fullUrl = getFullUrl(routes.tag(name.toLowerCase()));
  const schemaQuestions = miniQuizQuestions?.map((question) => ({
    questionText: question.stem,
    acceptedAnswerText: question.key,
  }));
  const schemas = [
    getGameSchema({
      name: `${categoryName} Trivia`,
      url: fullUrl,
      description,
    }),
    getQuizSchema({
      name: `${categoryName} Trivia`,
      url: fullUrl,
      description,
      questions: schemaQuestions,
    }),
  ];

  if (childTags.length > 0) {
    const itemListSchema = getItemListSchema(
      childTags.map((tag) => ({
        name: tag.display_name,
        url: getFullUrl(routes.tag(tag.slug)),
      }))
    );
    if (Object.keys(itemListSchema).length > 0) {
      schemas.push(itemListSchema);
    }
  }

  return schemas;
}

function getGameSchemas(name: string, path: string, description: string): object[] {
  const url = getFullUrl(path);

  return [getGameSchema({ name, url, description }), getQuizSchema({ name, url, description })];
}
